<template>
  <div class="box">
    <table class="table is-fullwidth is-striped">
      <thead></thead>
      <tbody>
        <tr>
          <th width="30%">{{ $t("devices.deviceId") }}</th>
          <td>{{ device.deviceId }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.deviceType") }}</th>
          <td>{{ device.deviceType }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.deviceLocate") }}</th>
          <td>{{ device.deviceLocate }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.address") }}</th>
          <td>{{ device.address }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.antenna") }}</th>
          <td>{{ device.antenna }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.battery") }}</th>
          <td>{{ device.battery }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.fileCount") }}</th>
          <td>{{ device.movies }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.movieDuration") }}</th>
          <td>{{ device.movieDuration }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.temperature") }}</th>
          <td>{{ device.temperature }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.aiLevel") }}</th>
          <td>
            {{
              device.aiLevel === "High"
                ? $t("devices.highAILevel")
                : device.aiLevel === "Mid"
                ? $t("devices.midAILevel")
                : device.aiLevel === "Low"
                ? $t("devices.lowAILevel")
                : $t("devices.defaultAILevel")
            }}
          </td>
        </tr>
        <!-- <tr>
          <th>{{ $t("devices.enabledUndetectedarea") }}</th>
          <td>
            {{
              device.enabledUndetectedarea
                ? $t("devices.undetectedareaStataus.enable")
                : $t("devices.undetectedareaStataus.disable")
            }}
          </td>
        </tr> -->
        <tr>
          <th>{{ $t("Created_at") }}</th>
          <td>{{ device.created_at }}</td>
        </tr>
        <tr>
          <th>{{ $t("Updated_at") }}</th>
          <td>{{ device.updated_at }}</td>
        </tr>
        <tr>
          <th>{{ $t("Note") }}</th>
          <td>{{ device.note }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    device: {
      type: Object,
      require: true,
    },
  },
};
</script>
